export const cookieSettingsModalText = {
  title: 'Privacy Preference Center',
  description: `When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose to allow or not to allow some types of cookies. If you click "Accept all," you're consenting to the placement and use of cookies as described in the different category headings outlined here. If you want to provide consent for some types of cookies but not others, click on the different category headings to find out more about each type of cookie and to adjust your settings according to your preference. If you click "Reject all," you're rejecting the placement and use of all cookies other than non-essential cookies. Please note that deciding not to allow some types of cookies may impact your experience of the site and the services we are able to offer. To learn more about our use of cookies and other tracking technology, see our Privacy Policy.`,
  categories: {
    strictlyNecessary: {
      title: 'Strictly Necessary Cookies',
      alwaysActive: '(Always Active)',
      description:
        'We use these cookies to ensure our site functions properly; they are necessary for our services to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.',
    },
    performance: {
      title: 'Performance/Analytical Cookies',
      description:
        'We use these cookies to count visits and traffic so we can understand, measure and improve the performance of our site. For example, we can use these cookies to learn more about which features are the most popular with our users and where we may need to make improvements.',
    },
    functional: {
      title: 'Functional Cookies',
      description:
        'We use these cookies to remember your settings and preferences. For example, we may use these cookies to remember your language preferences.',
    },
    targeting: {
      title: 'Targeting/Advertising Cookies',
      description:
        'We and our advertising partners use these cookies to deliver advertisements, to make them more relevant and meaningful to you, and to track the efficiency of our advertising campaigns, both on our services and on other websites and social media.',
    },
  },
  buttons: {
    confirm: 'Confirm My Choices',
    allowAll: 'Allow All',
    rejectAll: 'Reject All',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    url: 'https://www.notion.so/healingpapercareer/Privacy-Policy-From-February-27th-2025-907c569149544fa1a1dc2ba48e6e5230',
  },
}
